import { useState as o, useRef as w, useCallback as C, useEffect as E } from "react";
function X(h) {
  const [e, r] = o(0), [i, S] = o(0), [u, p] = o(0), [f, l] = o(0), n = w(null), a = 25;
  function c(t) {
    t === "next" && e < h - 1 ? r((s) => s + 1) : t === "prev" && e > 0 && r((s) => s - 1);
  }
  const m = (t) => {
    l(0), p(t.touches[0].clientX);
  }, x = (t) => {
    l(t.touches[0].clientX);
  }, T = () => {
    if (!u || !f) return;
    const t = u - f, s = t > a, v = t < -a;
    s && c("next"), v && c("prev");
  }, d = C(() => {
    n.current && (S(n.current?.offsetWidth), n.current.style.transform = `translateX(${-(e * i)}px)`);
  }, [e, i]);
  return E(() => {
    setTimeout(() => {
      n.current && d();
    }, 0);
  }, [d, e]), {
    sliderRef: n,
    move: c,
    currentIndex: e,
    touchHandlers: {
      onTouchStart: m,
      onTouchMove: x,
      onTouchEnd: T
    }
  };
}
export {
  X as useCardCarousel
};
